module.exports = __webpack_public_path__ + "img/蒙版组 1@12x.13d68032.webp";